import * as React from "react"

export function useMediaQuery(query: string, defaultMatches: boolean = false) {
  const [matches, setMatches] = React.useState(defaultMatches)

  React.useEffect(() => {
    const mql = matchMedia(query)

    setMatches(mql.matches)

    mql.onchange = () => setMatches(mql.matches)

    return () => {
      mql.onchange = null
    }
  }, [query])

  return matches
}
